import {getQueryStringArgs} from '../lib/query-string';
import {messyParams} from '../lib/messy-params';

// from=tr 来自教研平台
let {
    fr,
    role,
    canSave,
    projectType,
    adapt
} = getQueryStringArgs(location.search);

if (window.qiankunData) {
    if (!fr) { 
        fr = window.qiankunData.fr;
    }
    if (!role) {
        role = window.qiankunData.role;
    }
    if (!canSave) {
        canSave = window.qiankunData.canSave;
    }
    if (!projectType) {
        projectType = window.qiankunData.projectType;
    }
}

const getIsFromIts = frStr => frStr === 'tr'; // 来源：its 教学系统
const getIsFromMgr = frStr => frStr === 'mgr'; // 来源：录题后端
const getIsFromTs = frStr => frStr === 'ts'; // 内部
const getIsFromXesOnline = frStr => frStr === 'xes-online'; // 学而思在线

// eslint-disable-next-line no-shadow
const getIsCanSave = () => Boolean(Number(canSave));

// eslint-disable-next-line no-shadow
const getIsCanReset = () => !Number(adapt);

// eslint-disable-next-line no-shadow
const getIsCanShare = () => true;

const getIsCanNewProject = role => true; // role !== '1';

const getIsCanUpload = role => true; // role !== '1';

const initialState = {
    fr,
    role,
    canSaveProj: getIsCanSave(role, canSave, projectType),
    canResetProj: getIsCanReset(role, projectType),
    canShareProj: getIsCanShare(role, projectType),
    canNewProject: getIsCanNewProject(role),
    canUpload: getIsCanUpload(role)
};

const reducer = function (state) {
    if (typeof state === 'undefined') state = initialState;
    return state;
};

export {
    reducer as default,
    getIsFromIts,
    getIsFromMgr,
    getIsFromTs,
    getIsFromXesOnline
};
